import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { set } from "lodash";
import { defaultFormData, initialState } from "./initialState";
import { IData, IItems } from "../types";
import { DataActiveStatusEnum } from "../../Category/types";

export const useClinicSlice = createSlice({
  name: "packageState",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setItemsLoading: (state, action: PayloadAction<boolean>) => {
      state.itemsLoading = action.payload;
    },
    setButtonLoading: (state, action: PayloadAction<boolean>) => {
      state.buttonLoading = action.payload;
    },
    setToggleLoading: (state, action: PayloadAction<boolean>) => {
      state.toggleLoading = action.payload;
    },
    setSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
    setPageNo: (state, action: PayloadAction<number>) => {
      state.pageNo = action.payload;
    },
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload;
    },
    setTotalRow: (state, action: PayloadAction<number>) => {
      state.totalRow = action.payload;
    },

    setOrderDir: (state, action: PayloadAction<string>) => {
      state.orderDir = action.payload;
    },
    setOrderBy: (state, action: PayloadAction<string>) => {
      state.orderBy = action.payload;
    },

    updateFormValue: (
      state,
      action: PayloadAction<{ key: string; value: any }>
    ) => {
      set(state, `formData.${action.payload.key}`, action.payload.value);
    },
    loadItemsInit: (
      state,
      action: PayloadAction<IItems[]>
    ) => {
      if (state.formData.items.length === 0) {
        state.formData.items = action.payload;
      }
    },
    updateItemsFormValue: (
      state,
      action: PayloadAction<{ name: string; value: any; groupId: string }>
    ) => {
      const index = state.formData.items.findIndex(
        (item) => item.groupId === action.payload.groupId
      );
      if (index !== -1) {
        set(
          state,
          `formData.items[${index}].${action.payload.name}`,
          action.payload.value
        );
      } else {
        state.formData.items.push({
          groupId: action.payload.groupId,
          [action.payload.name]: action.payload.value,
        } as IItems);
      }
    },
    setInitialFormItems: (state, action: PayloadAction<IItems[]>) => {
      state.formData.items = action.payload;
    },

    clearFrom: (state) => {
      state.formData = { ...defaultFormData };
    },
    clearItemsFrom: (state) => {
      state.formData.itemsForm = { ...defaultFormData.itemsForm };
    },
    setItemsFromData: (state, action: PayloadAction<IItems>) => {
      state.formData.items.push(action.payload);
    },

    doCreate: (state, action: PayloadAction<{ callback: () => void }>) => {},
    doUpdate: (state, action: PayloadAction<{ callback: () => void }>) => {},
    doCreateItems: (
      state,
      action: PayloadAction<{ callback: () => void }>
    ) => {},

    doRemoveImages: (
      state,
      action: PayloadAction<{
        name: string;
        index: number;
      }>
    ) => {
      const { name, index } = action.payload;
      const items = state.formData[name as keyof IData];

      if (!items || !Array.isArray(items)) return;

      const imageItem = items[index];

      if (imageItem?._id) {
        items[index] = {
          ...imageItem,
          isRemove: true,
        };
      } else {
        items.splice(index, 1);
      }
    },

    updateImagesFormValue: (
      state,
      action: PayloadAction<{ name: string; value: any }>
    ) => {
      const { name, value } = action.payload;
      (state.formData[name as keyof IData] as any[]).push({ file: value });
    },
    updateFeaturedImageFormValue: (state, action: PayloadAction<string>) => {
      const newImage = action.payload;

      if (state.formData.featuredImage.length > 0) {
        state.formData.featuredImage.forEach((img) => {
          img.isRemove = true;
        });
      }
      state.formData.featuredImage.push({
        file: newImage,
        _id: "",
        isRemove: false,
      });
    },
    doRemoveItems: (
      state,
      action: PayloadAction<{
        index: number;
      }>
    ) => {
      const items = state.formData.items;
      if (
        items[action.payload.index] &&
        //@ts-ignore
        items[action.payload.index]?.["_id"]?.length > 0
      ) {
        items[action.payload.index].remove = true;
      } else {
        items.splice(action.payload.index, 1);
      }
    },
    doUpdateStatus: (
      state,
      action: PayloadAction<{
        id: string;
        index: number;
        callback: () => void;
      }>
    ) => {
      state.list[action.payload.index].status =
        state.list[action.payload.index].status === DataActiveStatusEnum.ACTIVE
          ? DataActiveStatusEnum.INACTIVE
          : DataActiveStatusEnum.ACTIVE;
    },

    doGetById: (state, action: PayloadAction<string>) => {
      state.loading = true;
    },
    doGetList: (state) => {
      if (!state.toggleLoading) {
        state.loading = true;
      }
    },
    setList: (state, action: PayloadAction<Array<IData>>) => {
      state.list = action.payload;
    },
    setDataForm: (state, action: PayloadAction<IData>) => {
      state.formData = action.payload;
    },
    doGetAllPackageList: (state) => {},
    setAllList: (state, action: PayloadAction<Array<IData>>) => {
      state.allList = action.payload;
    },
  },
});

export const { reducer, actions, name: sliceKey } = useClinicSlice;
